import { makeStyles } from '@material-ui/core/styles';

const useStylesDescription = makeStyles({
  list: {
    margin: 0,
    listStyleType: 'disc',
    padding: 0,
    paddingLeft: '25px',
  },

  listItem: {
    margin: 0,
    padding: 0,
  },
});

export { useStylesDescription };
